<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">创业诊断预约管理</div>
          <span class="m-title-s">对创业诊断预约查看接单操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>系统管理员列表
          </div>
          <div class="m-table-btn">
          </div>
        </el-container>
        <el-container class="m-table-opt">
          <div class="m-table-opt-item"
               :class="isPay === '1' && isEnd === '0' ? 'm-table-opt-this' : ''" @click="loadOpt('1', '0')">
            已支付
          </div>
          <div class="m-table-opt-item"
               :class="isPay === '0' && isEnd === '0' ? 'm-table-opt-this' : ''" @click="loadOpt('0', '0')">
            未支付
          </div>
          <div class="m-table-opt-item"
               :class="isPay === '1' && isEnd === '1' ? 'm-table-opt-this' : ''" @click="loadOpt('1', '1')">
            已结束
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="userName" label="用户姓名"></el-table-column>
          <el-table-column prop="phone" label="电话" align="center" width="120"></el-table-column>
          <el-table-column prop="status" label="接诊状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '0'" type="info">未接诊</el-tag>
              <el-tag v-if="scope.row.status === '1'" type="success">诊断结束</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="payStatus" label="支付状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.payStatus === '0'" type="info">未支付</el-tag>
              <el-tag v-if="scope.row.payStatus === '1'" type="success">已支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="payMoney" label="支付金额" align="center">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.payMoney }} 元</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="tradeNo" label="订单号" width="170" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="payDate" label="支付时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="warning" size="mini" @click="openForm(scope.row)" plain>查看</el-button>
              <el-button v-if="scope.row.status === '0'" type="primary" size="mini" @click="openSubForm(scope.row)" plain>编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="详细信息" :visible.sync="openState" @close='closeDialog' width="950px" :close-on-click-modal="false">
      <div class="m-user-open">
        <div class="m-user-open-item">
          <label>申请姓名：</label>
          <div class="m-user-open-cont">{{form.userName}}</div>
        </div>
        <div class="m-user-open-item">
          <label>申请电话：</label>
          <div class="m-user-open-cont">{{form.phone}}</div>
        </div>
        <div class="m-user-open-item">
          <label>订单号：</label>
          <div class="m-user-open-cont">{{form.tradeNo}}</div>
        </div>
        <div class="m-user-open-item">
          <label>接诊状态：</label>
          <el-tag v-if="form.status === '0'" type="info">未接诊</el-tag>
          <el-tag v-if="form.status === '1'" type="success">诊断结束</el-tag>
        </div>
        <div class="m-user-open-item">
          <label>支付状态：</label>
          <el-tag v-if="form.payStatus === '0'" type="info">未支付</el-tag>
          <el-tag v-if="form.payStatus === '1'" type="success">已支付</el-tag>
        </div>
        <div class="m-user-open-item">
          <label>支付时间：</label>
          <div class="m-user-open-cont">{{form.payDate}}</div>
        </div>
        <div class="m-user-open-item">
          <label>支付金额：</label>
          <div class="m-user-open-cont" style="color: #ff4d51; font-weight: bold;">{{ form.payMoney }}元</div>
        </div>
        <div class="m-user-open-item">
          <label>创建时间：</label>
          <div class="m-user-open-cont">{{ form.createDate }}</div>
        </div>
        <div class="m-user-open-item" style="width: 100%;">
          <label>申请说明：</label>
          <div class="m-user-open-cont">{{form.explain}}</div>
        </div>
        <div class="m-user-open-item" style="width: 100%;">
          <label>备注：</label>
          <div class="m-user-open-cont">{{form.remarks}}</div>
        </div>
        <div class="m-user-open-item">
          <label>修改时间：</label>
          <div class="m-user-open-cont">{{form.updateDate}}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-foote" style="text-align: center;">
        <el-button @click="openState = false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 音频编辑 -->
    <el-dialog width="750px" title="编辑信息" :visible.sync="openFormState" @close='closeForm' center :close-on-click-modal="false">
      <div v-loading="formLoading" class="m-open-container">
        <el-form :model="subForm" ref="audioForm" label-width="100px">
          <el-form-item label="备注：">
            <el-input v-model="subForm.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
          </el-form-item>
          <el-form-item label="接诊状态：">
            <el-switch v-model="isStatus" active-text="诊断结束" inactive-text="未接诊"></el-switch>
          </el-form-item>
          <div style="text-align: center;">
            <el-button @click="openFormState = false">取 消</el-button>
            <el-button type="primary" @click="submitForm()">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Manager',
  data () {
    return {
      openState: false,
      openFormState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      isPay: '',
      isEnd: '',
      form: {
        id: '',
        tradeNo: '',
        userId: '',
        userName: '',
        phone: '',
        explain: '',
        status: '', // 接诊状态
        payStatus: '', // 支付状态
        payMoney: '', // 支付金额（分）
        createDate: '',
        payDate: '',
        updateDate: '',
        remarks: ''
      },
      subForm: {
        tradeNo: '',
        remarks: '',
        status: ''
      }
    }
  },
  methods: {
    closeDialog: function () {
      this.form = {
        id: '',
        phone: '',
        nickname: '',
        login_flag: '1',
        roleId: '',
        remarks: ''
      }
      this.formLoading = false
    },
    closeForm () {
      this.subForm = {
        tradeNo: '',
        remarks: '',
        status: ''
      }
    },
    openSubForm (row) {
      this.openFormState = true
      this.isStatus = row.status === '1'
      this.subForm = {
        tradeNo: row.tradeNo,
        remarks: row.remarks,
        status: row.status
      }
    },
    submitForm () {
      let _this = this
      _this.subForm.status = _this.isStatus === true ? '1' : '0'
      _this.formLoading = true
      this.$axios.post('/doctor/userApply/updateStatus', _this.subForm)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.listData(this.isPay, this.isEnd)
            _this.openFormState = false
            _this.formLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.formLoading = false
          }
        })
    },
    openForm (row) {
      this.openState = true
      this.form = row
    },
    loadOpt (type, isEnd) {
      if (this.isPay === type && this.isEnd === isEnd) return
      this.listData(type, isEnd)
    },
    // 列表
    listData (type, isEnd) {
      let _this = this
      _this.isPay = type
      _this.isEnd = isEnd
      _this.isLoading = true
      _this.list = []
      this.$axios.post('/doctor/userApply/list', {isPay: type, isEnd: isEnd})
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData('1', '0')
  }
}
</script>

<style scoped>
.m-user-open {
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  transition: .3s;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
}

.m-user-open-item {
  width: 48%;
  display: flex;
  min-height: 40px;
  align-items: center;
  border: 1px solid #f2f2f2;
  box-sizing: border-box;
  margin: 5px 1%;
  border-radius: 5px;
  padding: 5px 0 5px 0;
}

.m-user-open-item label {
  width: 100px;
  text-align: right;
  box-sizing: border-box;
}

.m-user-open-cont {
  padding-right: 10px;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/doctor/UserApply.vue